<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <w-form class="" v-model="valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="success">
      <z-page :title="title">
        <div class="w-card__content content-hardcode">
          <div class="w-flex wrap smd-column">
            <div class="grow">
              <z-select class="mt4" outline :items="premis" label="ID / Nama Premis *" v-model="form.premis_id" @input="getTernakan(form)" :validators="[validators.required]"/>
              &nbsp;
              <z-select class="mt4" outline :items="lkp_ternakan" label="Jenis Ternakan *" v-model="form.lkp_ternakan_id" @input="getTernakan(form)" :validators="[validators.required]"/>
              &nbsp;
              <w-select 
                class="mt4" 
                outline 
                :items="pemeriksa" 
                label="Nama Pegawai Pemeriksa*" 
                v-model="form.juruteknik_id" 
                :validators="[validators.required]"
                @mousedown.prevent="Pemeriksaan(form)"
              />
            </div>
            <div class="mx2"></div>
            <div class="grow">
              <br>
              <div style="margin: 17px 0 8px; gap: 10px;" class="fw-normal my1 fs-1"><b>Negeri : </b>{{form.lkp_negeri}}</div>
              &nbsp;
              <z-select class="mt4" outline :items="lkp_tujuan" label="Tujuan *" v-model="form.lkp_tujuan_id" @input="getTernakan(form)" :validators="[validators.required]"/>
              <br>
              <br>
              <template v-if="form.lkp_negeri_id">
                <div class="d-flex align-center" style="margin: 17px 0; gap: 10px;">
                  <b class="fs-1" style="min-width: 70px;">Pasung :</b>
                  <w-radios
                    v-model="form.pasung"
                    :items="pasung_list"
                    inline
                    color="blue-light1"
                  ></w-radios>
                </div>
              </template>
            </div>
          </div>
        </div>
        <br>
        
        <!-- CARIAN FILTER UNTUK JADUAL UTAMA -->
        <div class="filter-container">
          <div class="filter-wrapper">
            <div class="filter-input-group">
              <w-input 
                class="filter-input"
                placeholder="Carian ID Ternakan atau Nama Ternakan..."
                v-model="filter_carian"
                clearable
                @input="filterTernakanList"
              >
                <template #prepend>
                  <w-icon>fal fa-search</w-icon>
                </template>
              </w-input>
              <w-button 
                v-if="filter_carian" 
                class="clear-filter-btn ml1" 
                @click="clearFilter"
                outline
                small
              >
                <w-icon class="mr1">fal fa-times</w-icon> Clear
              </w-button>
            </div>
            <div v-if="filter_carian && ternakan_list_original && ternakan_list_original.length" class="filter-info">
              <span class="badge-filter">
                <w-icon class="mr1">fal fa-search</w-icon> 
                Ditemui: {{ (filtered_ternakan_list || []).length }} daripada {{ (ternakan_list_original || []).length }} rekod
              </span>
            </div>
          </div>
        </div>
        
        <div class="modern-table-container" style="max-height: 400px;">
          <div class="table-scroll-wrapper">
            <table class="modern-table">
              <thead>
                <tr>
                  <th class="table-header text-left" width="1%">BIL</th>
                  <th class="table-header text-left">NO PENDAFTARAN</th>
                  <th class="table-header text-left">ID | NAMA TERNAKAN</th>
                  <th class="table-header text-left">JENIS TERNAKAN</th>
                  <th class="table-header text-left">BAKA</th>
                  <th class="table-header text-center">UMUR (BULAN)</th>
                  <th class="table-header text-left">BILANGAN PEMERIKSAAN</th>
                  <th class="table-header text-left">TARIKH AKHIR PEMERIKSAAN</th>
                  <th class="table-header text-center">SILA PILIH TERNAKAN YANG HENDAK DIPERIKSA</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="!filtered_ternakan_list || filtered_ternakan_list.length == 0">
                  <tr class="table-row">
                    <td class="table-cell text-center" colspan="9">
                      <div class="no-data">
                        <w-icon class="mr2">fal fa-inbox</w-icon> 
                        <span v-if="filter_carian">Tiada hasil carian untuk "{{ filter_carian }}"</span>
                        <span v-else>Tiada Data.</span>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="(dt, ind) in filtered_ternakan_list" :key="dt.ternakan_id || ind" class="table-row" :class="{ 'row-hover': true, 'highlight-match': isMatchFilter(dt) }">
                    <td class="table-cell text-left">{{ind+1}}</td>
                    <td class="table-cell text-left">{{dt.kode || '-'}}</td>
                    <td class="table-cell text-left" style="text-transform: uppercase;">
                      <span v-html="highlightText((dt.id_ternakan || '') + ' | ' + (dt.nama || ''))"></span>
                    </td>
                    <td class="table-cell text-left">{{dt.ternakan || '-'}}</td>
                    <td class="table-cell text-left">{{dt.baka || '-'}}</td>
                    <td class="table-cell text-center">{{$zutil.umurBln(dt.tarikh_lahir) || 0}}</td>
                    <td class="table-cell text-left">{{dt.bil_pemeriksaan || 0}}</td>
                    <td class="table-cell text-left">{{$zutil.dateformat(dt.tarikh_pemeriksaan)}}</td>
                    <td class="table-cell text-center">
                      <w-checkbox v-model="dt.pilih" @input="klickPilih(dt)" class="row-checkbox"></w-checkbox>
                    </td>
                   </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        
        <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['1', '2', '5'])">
          <w-button class="my1" :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
            <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
          </w-button>
          &nbsp;
          <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
            <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
          </w-button>
        </w-flex>
        <div class="mt2 text-left">
          <w-button style="background-color: #f0f0f0; border: 2px solid red; color: #333; padding: 7px 14px; font-size: 10px; font-weight: bold; border-radius: 4px; cursor: pointer;" @click="tutup">TUTUP</w-button>&nbsp;
        </div>
      </z-page>
    </w-form>

    <w-dialog
      v-model="dialog.show"
      :fullscreen="dialog.fullscreen"
      width="800"
      :persistent="dialog.persistent"
      :persistent-no-animation="dialog.persistentNoAnimation"
      title-class="primary-dark1--bg white"
    >
      <template #title>CARIAN PEMERIKSA</template>
      <w-flex justify-center align-center>
        <div class="xs8">
          <w-input label="Nama Pemeriksa (Carian minimum 2 aksara)" v-model="carian_pemeriksa.q"></w-input>
        </div>
        <div class="xs4">
          <w-button class="ml1" @click="getPemeriksa(form)">Cari</w-button>
        </div>
      </w-flex>
      <br><br>
      <div class="w-table-wrap" style="max-height: 400px;">
        <div class="table-profil-scrol">
          <table class="w-table">
            <thead>
              <tr>
                <th class="w-table__header w-table__header--sortable text-left">No</th>
                <th class="w-table__header w-table__header--sortable text-left">Nama</th>
                <th class="w-table__header w-table__header--sortable text-left">Pilih</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(dt, index) in pemeriksa" :key="index">
                <td class="w-table__cell text-left">{{index+1}}</td>
                <td class="w-table__cell">{{dt.label}}</td>
                <td class="w-table__cell text-right">
                  <w-radio class="mr2" v-model="form.juruteknik_id" :return-value="dt.value" @click="dialog.show = false"></w-radio>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <template #actions>
        <div class="spacer" />
        <w-button style="background-color: #f0f0f0; border: 2px solid red; color: #333; padding: 7px 14px; font-size: 10px; font-weight: bold; border-radius: 4px; cursor: pointer;" @click="dialog.show = false">TUTUP</w-button>
      </template>
    </w-dialog>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    id: [Array, Object],
    d_form: [Array, Object],
    d_lkp_negeri: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'art.permohonan', 
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Permohonan', route: '#' },
        { label: 'Pemeriksaan Fertiliti', route: 'art/permohonan/ferteliti/0' },
      ],
      negeri : '',
      title : 'PDBF Permohonan',
      form : this.d_form,
      lkp_negeri : this.d_lkp_negeri,
      ternakan_list: [],
      ternakan_list_original: [],
      filtered_ternakan_list: [],
      filter_carian: '',
      premis : [],
      pemeriksa : [],
      lkp_ternakan : [],
      lkp_status : [],
      jantina : [],
      lkp_tujuan: [],
      pasung_list:[
        {value: 1, label: "ADA"},
        {value: 2, label: "TIADA"},
      ],
      loading : 0,
      checkin: false,
      carian_pemeriksa : {q: ''},
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 900,
        item: {}
      }
    }
  },
  methods: {
    // Filter functions
    filterTernakanList() {
      try {
        if (!this.filter_carian || this.filter_carian.trim() === '') {
          this.filtered_ternakan_list = this.ternakan_list_original ? [...this.ternakan_list_original] : [];
          return;
        }
        
        const searchTerm = this.filter_carian.toLowerCase().trim();
        const originalList = this.ternakan_list_original || [];
        
        this.filtered_ternakan_list = originalList.filter(item => {
          if (!item) return false;
          const idTernakan = (item.id_ternakan || '').toLowerCase();
          const namaTernakan = (item.nama || '').toLowerCase();
          const kode = (item.kode || '').toLowerCase();
          
          return idTernakan.includes(searchTerm) || 
                 namaTernakan.includes(searchTerm) ||
                 kode.includes(searchTerm);
        });
      } catch (error) {
        console.error('Error filtering:', error);
        this.filtered_ternakan_list = this.ternakan_list_original ? [...this.ternakan_list_original] : [];
      }
    },
    
    isMatchFilter(item) {
      if (!this.filter_carian || !item) return false;
      const searchTerm = this.filter_carian.toLowerCase().trim();
      const idTernakan = (item.id_ternakan || '').toLowerCase();
      const namaTernakan = (item.nama || '').toLowerCase();
      
      return idTernakan.includes(searchTerm) || namaTernakan.includes(searchTerm);
    },
    
    highlightText(text) {
      if (!this.filter_carian || !text) return text;
      
      try {
        const searchTerm = this.filter_carian.toLowerCase().trim();
        const textLower = text.toLowerCase();
        
        if (textLower.includes(searchTerm)) {
          const regex = new RegExp(`(${this.escapeRegExp(searchTerm)})`, 'gi');
          return text.replace(regex, '<span class="highlight-text">$1</span>');
        }
        return text;
      } catch (error) {
        return text;
      }
    },
    
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    
    clearFilter() {
      this.filter_carian = '';
      this.filtered_ternakan_list = this.ternakan_list_original ? [...this.ternakan_list_original] : [];
    },
    
    Pemeriksaan(form){
      this.dialog.show = true;
      this.form.saveButton = "Simpan"
    },
    
    send(hantar){
      this.form.hantar = hantar
    },

    klickPilih(dt) {
      if (dt.pilih) {
        this.$zcomm.get(this.api_service + 'check_ternakan/' + dt.ternakan_id)
          .then(res => {
            if (res.exists) {
              this.$zutil.notify("Ternakan ini telah dimohon sebelumnya!", false);
              dt.pilih = false;
            }
          }).catch(err => console.error('Error checking ternakan:', err));
      }
    },
     
    onValidate() {
      this.loading=true;
      let isValid = true;
      let jumlah_lulus = 0;
      for (var i in this.ternakan_list) {
        if (this.form.lkp_art_id == 1 && (this.ternakan_list[i].pilih==false && this.ternakan_list[i].jenis_semen!=0 || this.ternakan_list[i].jenis_semen==0 && this.ternakan_list[i].pilih==true)) {
          isValid = false;
          break;
        }
        if(this.ternakan_list[i].pilih==true && this.ternakan_list[i].jenis_semen!=0){
          jumlah_lulus = 1;
        }
      };
      if(!this.form.premis_id || !this.form.juruteknik_id || !this.form.lkp_ternakan_id){
        isValid = false;
      }
      if(jumlah_lulus == 0 && isValid == true){
        isValid = false;
      }
      if (!isValid) {
        this.$zutil.notify("Pastikan data sudah dipilih", false);
        this.loading=false;
        return false;
      }
      this.onSuccess();
    },

    onSuccess(){
      this.form.lkp_art_id = 6;
      this.form.ternakan_list = this.ternakan_list;
      if(this.form.hantar == 1){
        this.$swal({
          title: 'Anda Pasti?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            if (this.form.id > 0){
              this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
              .then(res => {
                if (typeof this.onAfterEdit === "function") this.onAfterEdit()
                this.$zutil.notify("Berjaya dihantar", true);
                if (this.form.hantar==1) {
                  this.$inertia.visit(this.$route('art.semakan.index', this.form.id));
                } else {
                  this.$zutil.notify("Berjaya disimpan", true);
                }
              }).catch(err => console.error('Error updating:', err));
            } else {
              this.$zcomm.post(this.resourceurl+'.store', this.form)
              .then(res => {
                if (typeof this.onAfterAdd === "function") this.onAfterAdd()
                this.$zutil.notify("Berjaya dihantar", true);
                this.$inertia.visit(window.route('art.semakan.index', res.id));
              }).catch(err => console.error('Error posting:', err));
            }
          }
        })
      } else {
        if (this.form.id > 0) {
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") this.onAfterEdit()
            if (this.form.hantar==1) {
              this.$zutil.notify("Berjaya dihantar", true);
              this.$inertia.visit(this.$route('art.semakan.index'));
            } else {
              this.$zutil.notify("Berjaya disimpan", true);
              this.$inertia.visit(this.$route('art.permohonan.ferteliti', this.form.id));
            }
          }).catch(err => console.error('Error updating:', err));
        } else {
          this.$zcomm.post(this.resourceurl+'.store', this.form)
          .then(res => {
            if (typeof this.onAfterAdd === "function") this.onAfterAdd()
            this.$zutil.notify("Berjaya disimpan", true);
            this.$inertia.visit(this.$route('art.permohonan.ferteliti', res.id));
          }).catch(err => console.error('Error posting:', err));
        }
      }
    },

    getPremis(){
      this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
        this.premis = res || []
      }).catch(err => console.error('Error loading premis:', err));
    },

    getData(){
      this.getTernakan(this.d_form);
    },

    getTujuan() {
      const params = { lkp_art_id: 6 };
      this.$zcomm.get(this.api_service + 'lookup/tujuan', params).then(res => {
        this.lkp_tujuan = res || []
      }).catch(err => console.error('Error loading tujuan:', err));
    },

    getTernakan(data){
      data.jantina = 2;
      if(data.premis_id !='' && data.lkp_ternakan_id !='' && data.jantina !=''){
        this.$zcomm.get(this.api_service + 'pdbf/ternakan_pdbf/'+data.premis_id+'/'+data.lkp_ternakan_id+'/'+data.jantina, {}).then(res => {
          this.ternakan_list_original = res || []
          this.ternakan_list = res || []
          this.filtered_ternakan_list = res || []
          
          if(data.ternakan_list && data.ternakan_list.length > 0){
            for (var i in this.ternakan_list) {
              for (var t in data.ternakan_list) {
                if(this.ternakan_list[i] && data.ternakan_list[t] && this.ternakan_list[i].ternakan_id == data.ternakan_list[t].ternakan_id){
                  this.ternakan_list[i].pilih = true
                }
              }
            }
          }
        }).catch(err => console.error('Error loading ternakan:', err));
      }
      for (var b in this.premis) {
        if(this.premis[b] && this.premis[b].value == data.premis_id){
          this.form.lkp_negeri_id = this.premis[b].lkp_negeri_id;
          this.form.lkp_negeri = this.premis[b].lkp_negeri;
          this.getPemeriksa(this.premis[b]);
        }
      }
    },

    getJenisTernakan(){
      this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
        this.lkp_ternakan = res || []
      }).catch(err => console.error('Error loading jenis ternakan:', err));
    },

    getJantina(){
      this.$zcomm.get(this.api_service + 'lookup/jantina', {}).then(res => {
        this.jantina = (res || []).filter(item => item.value == 2);
        if (this.jantina.length === 1) {
          this.form.jantina = this.jantina[0].value;
        }
      }).catch(err => console.error('Error loading jantina:', err));
    },

    getPemeriksa(data){
      this.$zcomm.get(this.api_service + 'lookup/pemeriksa', {lkp_negeri_id: data.lkp_negeri_id, carian_pemeriksa: this.carian_pemeriksa.q}).then(res => {
        this.pemeriksa = res || []
      }).catch(err => console.error('Error loading pemeriksa:', err));
    },

    tutup(){
      this.$inertia.visit(window.route('art.semakan.index'));
    },
  },

  watch: {
    premis: {
      handler(newVal) {
        if (newVal && newVal.length === 1) {
          this.form.premis_id = newVal[0].value;
          this.getTernakan(this.form);
        }
      },
      immediate: true,
    },
    lkp_ternakan: {
      handler(newVal) {
        if (newVal && newVal.length === 1) {
          this.form.lkp_ternakan_id = newVal[0].value;
          this.getTernakan(this.form);
        }
      },
      immediate: true,
    },
  },
  
  mounted() {
    var today = new Date();
    this.tarikh_today = today.toISOString().split('T')[0];
    this.title = 'Permohonan Pemeriksaan Fertiliti'
    this.form.jantina = "Betina";
    this.getPremis()
    this.getJenisTernakan()
    this.getData()
    this.getTujuan()
    this.getJantina()
  }
}
</script>

<style scoped>
.modern-table-container {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  background-color: #fff;
  border: 1px solid #eaeaea;
  margin-bottom: 16px;
}

.table-scroll-wrapper {
  overflow-x: auto;
  max-height: 400px;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

.table-scroll-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-scroll-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-scroll-wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 4px;
}

.modern-table {
  width: 100%;
  border-collapse: collapse;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.table-header {
  background-color: #f8f9fa;
  padding: 16px 12px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #eaeaea;
  position: sticky;
  top: 0;
  z-index: 10;
}

.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid #f0f0f0;
}

.table-row:hover {
  background-color: #f8f9fa;
}

.table-row:nth-child(even) {
  background-color: #fbfcfd;
}

.table-row:nth-child(even):hover {
  background-color: #f0f4f8;
}

.table-cell {
  padding: 14px 12px;
  font-size: 0.9rem;
  color: #333;
  vertical-align: middle;
}

.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #888;
  font-size: 1rem;
}

.row-checkbox {
  transform: scale(1.1);
}

.filter-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #f8f9fa 100%);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 20px;
  border: 1px solid #e0e6ed;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.filter-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.filter-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-input {
  flex: 1;
}

.clear-filter-btn {
  white-space: nowrap;
}

.filter-info {
  margin-top: 8px;
}

.badge-filter {
  display: inline-flex;
  align-items: center;
  background-color: #e8f0f5;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  color: #2c7da0;
  font-weight: 500;
}

.highlight-match {
  background-color: #fff3cd !important;
}

.highlight-text {
  background-color: #ffeb3b;
  color: #333;
  font-weight: bold;
  padding: 0 2px;
  border-radius: 3px;
}

.mt1 { margin-top: 4px; }
.mt2 { margin-top: 8px; }
.mt3 { margin-top: 16px; }
.ml1 { margin-left: 8px; }
.mr1 { margin-right: 8px; }

@media (max-width: 768px) {
  .table-header {
    font-size: 0.75rem;
    padding: 12px 8px;
  }
  .table-cell {
    font-size: 0.8rem;
    padding: 10px 8px;
  }
}
</style>